import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppColor } from 'application/components/api/EppColor';

export const eppColorAdapter = createEntityAdapter<IEppColor, number>({
  selectId: (project) => project.eppColorID,
});
